import { Address } from '@api/address/models/address.models';
import { PhysicalStoreDetail } from '@api/store-locator/physical-store/models/physical-store.models';

export enum OrderTypeEnum {
    ONLINE = 'ONLINE',
    STORE = 'STORE',
}

export interface OrderCancelModal {
    hasSubOrders: boolean;
}

// En teoria esta interface ya estaria creada, no hace falta una nueva
/* export interface OrderEguiInfo {
} */

export interface OrderCancelConfirmationModal {
    orderId: string;
    isSubOrder: boolean;
}

export interface OrderAddressInfo {
    address?: Address;
    physicalStore?: PhysicalStoreDetail;
    addressLines: string;
    city: string;
    district?: string;
}

export type OrderStatus = 'canceled' | 'confirmed' | 'courier' | 'delivered' | 'dispatch' | 'preparation';
